(function(){
  'use strict';

  // Read config from script tag data attributes
  var scriptEl = document.getElementById('binb-urgency-script');
  var stockMax  = scriptEl ? parseInt(scriptEl.getAttribute('data-stock-max'),  10) || 50  : 50;
  var soldFloor = scriptEl ? parseInt(scriptEl.getAttribute('data-sold-floor'), 10) || 30  : 30;
  var timerHrs  = scriptEl ? parseInt(scriptEl.getAttribute('data-timer-hours'),10) || 3   : 3;

  // ── Urgency numbers
  var sold      = soldFloor + Math.floor(Math.random() * 8);
  var remaining = stockMax - sold;
  var pct       = Math.round((sold / stockMax) * 100);

  function q(id){ return document.getElementById(id); }

  var soldEl = q('binb-sold-count');
  var leftEl = q('binb-prog-left');
  var fillEl = q('binb-prog-fill');
  if(soldEl) soldEl.textContent = sold + ' bik chuke';
  if(leftEl) leftEl.textContent = remaining + ' bache hain';
  // Animate fill after paint
  requestAnimationFrame(function(){
    setTimeout(function(){ if(fillEl) fillEl.style.width = pct + '%'; }, 400);
  });

  // ── Live viewers
  var liveEl = q('binb-live-viewers');
  if(liveEl){
    var v = Math.floor(Math.random() * 12) + 5;
    liveEl.textContent = v + ' log abhi yeh product dekh rahe hain';
    setInterval(function(){
      v = Math.max(3, Math.min(25, v + (Math.random() > 0.5 ? 1 : -1)));
      liveEl.textContent = v + ' log abhi yeh product dekh rahe hain';
    }, 5000);
  }

  // ── Countdown timer (session-persistent)
  (function startTimer(){
    var key = 'binb_timer_v2';
    var end;
    try{ end = parseInt(sessionStorage.getItem(key)); } catch(e){}
    if(!end || isNaN(end)){
      end = Date.now() + timerHrs * 3600000;
      try{ sessionStorage.setItem(key, end); } catch(e){}
    }
    var pad = function(n){ return String(n).padStart(2, '0'); };
    function tick(){
      var diff = end - Date.now();
      if(diff <= 0){
        try{ sessionStorage.removeItem(key); } catch(e){}
        startTimer();
        return;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var hEl = q('bt-h'), mEl = q('bt-m'), sEl = q('bt-s');
      if(hEl) hEl.textContent = pad(h);
      if(mEl) mEl.textContent = pad(m);
      if(sEl) sEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  })();

  // ── YouTube facade: load iframe only on click (saves ~500KB per video)
  document.querySelectorAll('.binb-yt-card').forEach(function(card){
    var btn = card.querySelector('[data-yt-play]');
    if(!btn) return;
    btn.addEventListener('click', function(){
      var ytId = card.getAttribute('data-yt-id');
      if(!ytId) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0&playsinline=1';
      iframe.frameBorder = '0';
      iframe.allow = 'autoplay;encrypted-media;picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:none;';
      // Replace poster img + button with iframe
      card.innerHTML = '';
      card.appendChild(iframe);
      card.classList.add('playing');
    }, {once: true});
  });

  // ── TikTok / Instagram lazy iframes via IntersectionObserver
  if('IntersectionObserver' in window){
    var lazyIframes = document.querySelectorAll('.binb-ugc__card iframe[data-src]');
    var iframeObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        var iframe = entry.target;
        iframe.src = iframe.getAttribute('data-src');
        iframe.removeAttribute('data-src');
        iframeObserver.unobserve(iframe);
      });
    }, {rootMargin: '200px'});
    lazyIframes.forEach(function(iframe){ iframeObserver.observe(iframe); });
  } else {
    // Fallback: just set src
    document.querySelectorAll('.binb-ugc__card iframe[data-src]').forEach(function(iframe){
      iframe.src = iframe.getAttribute('data-src');
    });
  }

  // ── MP4 videos: tap to play / tap to pause, one at a time
  var mp4Cards = [].slice.call(document.querySelectorAll('[data-vid-card]'));
  var allVids  = mp4Cards
    .map(function(c){ return c.querySelector('[data-ugc-video]'); })
    .filter(Boolean);

  function pauseOthers(current){
    allVids.forEach(function(other){
      if(other !== current && !other.paused){ other.pause(); }
    });
  }

  mp4Cards.forEach(function(card){
    var btn = card.querySelector('[data-play-btn]');
    var vid = card.querySelector('[data-ugc-video]');
    if(!vid) return;

    function start(){
      pauseOthers(vid);
      // Customer review videos are worth hearing. Unmuting is allowed here
      // because play is always triggered by a real tap. If the browser still
      // refuses, fall back to muted playback rather than failing silently.
      vid.muted = false;
      var p = vid.play();
      if(p && p.catch){
        p.catch(function(){
          vid.muted = true;
          var retry = vid.play();
          if(retry && retry.catch){ retry.catch(function(){}); }
        });
      }
    }

    if(btn){ btn.addEventListener('click', start); }

    // Tapping the video itself toggles playback. Previously the play overlay
    // covered the whole card, so this was unreachable.
    vid.addEventListener('click', function(){
      if(vid.paused){ start(); } else { vid.pause(); }
    });

    // Drive the class off real playback state, not off the click handler,
    // so the overlay reappears whenever the video is genuinely paused.
    vid.addEventListener('playing', function(){ card.classList.add('playing'); });
    vid.addEventListener('pause',   function(){ card.classList.remove('playing'); });
    vid.addEventListener('ended',   function(){ card.classList.remove('playing'); });
  });

  // Pause MP4 videos that scroll out of view (saves data on mobile)
  if('IntersectionObserver' in window && allVids.length){
    var vidObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting && !entry.target.paused){ entry.target.pause(); }
      });
    }, {threshold: 0.25});
    allVids.forEach(function(v){ vidObserver.observe(v); });
  }

  // ── Upload tile preview
  var input = document.getElementById('binb-upload-input');
  if(input){
    input.addEventListener('change', function(){
      var file = this.files[0];
      if(!file || !file.type.startsWith('video/')) return;
      var url  = URL.createObjectURL(file);
      var label = input.closest('.binb-ugc__upload');
      var plus  = label && label.querySelector('.binb-upload-plus');
      if(plus) plus.style.display = 'none';
      var prev = document.createElement('video');
      prev.className = 'binb-preview';
      prev.src       = url;
      prev.autoplay  = true;
      prev.muted     = true;
      prev.loop      = true;
      prev.playsInline = true;
      if(label) label.appendChild(prev);
    });
  }

})();
